import { ThisOrThatQuiz } from "./Quiz-FoodCourt";
import { PriceQuiz } from "./Quiz-Damicos";
import {
  arcadeImages,
  clothingImages,
  musicImages,
  bookImages,
  salonImages,
  electronicsImages,
  cinemaImages,
  foodCourtImages,
  meetingAreaImages,
} from "./ImageImports";

import botBreakerImage from '../assets/hero/Bot_Breaker_Full_Size.jpg';
import starShooterImage from '../assets/hero/Crystal_Shooter_Full_Size.jpg'
import dressUpImage from '../assets/hero/ag-fc-court-sample-splash.png';

import courtneyBookCover from "../assets/hero/ag-courtney-cover.jpg";
import courtneyNewBookCover from "../assets/hero/ag-courtney-coverBOOK2.jpg";

const cameraSpeed = 1;

const MeetingArea = {
  id: 1,
  title: "Meeting Area",
  images: meetingAreaImages,
  copy: [
    "Welcome to Orange Valley Mall! This is, like, my favorite place to hang out—especially in the summer, when it gets super hot in California. The whole mall is air conditioned, and I always see my friends when I’m here. Want to look around with me? Come on! I’ll give you a tour.",
  ],
  camera: [[1.7397, -1.1464, 1.1209], [0.5119, -1.2676, 1.1845], cameraSpeed],
};
const Cinema = {
  id: 2,
  title: "Cinema",
  images: cinemaImages,
  copy: [
    "Orange Valley Mall has a movie theater with six screens, so there are plenty of choices. Sarah and Kip and I love going to the movies. (Especially Kip. He wants to be a movie director someday.) We all save enough allowance money to see at least one movie on the weekend. I always get popcorn, Sarah gets chocolate covered peanuts, and Kip gets red licorice.",
  ],
  videos: [
    "J344915",
    "J384711"
    // "6150340394001",
    // "6150338516001",
    // "6150338518001",
    // "6150339127001",
  ],
  camera: [[-0.457, -2.5764, 1.3458], [-0.4354, -4.3625, 1.4326], cameraSpeed],
};
const Valeries = {
  id: 3,
  title: "Valerie's",
  images: clothingImages,
  copy: [
    "The best place for totally gnarly clothes is Valerie’s. The outfit I’m wearing now came from this store. My favorite color is purple, and I love anything with bright, bold patterns. Whenever I get a new shirt or skirt or pair of leggings, I like to see how many different outfits I can create with the clothes I have at home. My stepsister, Tina, is, like, totally good at that. She always has the perfect hair tie for every look.",
  ],
  camera: [[-2.8328, -2.8984, 2.0064], [-3.4553, -3.3591, 1.7851], cameraSpeed],
  game: [
    {
      gameUrl: "https://play.americangirl.com/play/courtney-dress-up/",
      gameTitle: "Courtney Dress Up",
      gamePoster: dressUpImage
    },
  ],
};
const FoodCourt = {
  id: 4,
  title: "Food Court",
  images: foodCourtImages,
  copy: [
    "When Sarah and I come to the mall after school, we have one rule: snack first. We’re best friends, but our tastes are totally different. Find out if you’re more like me or more like Sarah with this quiz—just choose from each set of options.",
  ],
  quiz: ThisOrThatQuiz,
  camera: [[-0.4952, -1.3376, 1.3446], [-1.0877, 0.3026, 1.0423], cameraSpeed],
};
const Tunes = {
  id: 5,
  title: "Tunes",
  images: musicImages,
  copy: [
    "Tunes is a totally rad music store. They sell all the latest albums and tapes, and there’s always great music playing. When my best friend, Sarah, and I come in here to shop, we always end up dancing in the aisles. We can’t help it!",
  ],
  videos: [
    "J359988",
    "J359989",
    "J359990",
    "J366990",
    // "6150339127001",
  ],
  camera: [[-2.2459, -4.0509, 3.6969], [-2.266, -4.7237, 3.5412], cameraSpeed],
};
const Damicos = {
  id: 6,
  title: "D’Amico’s",
  images: electronicsImages,
  copy: [
    "D’Amico’s Electronics is the best place to get the latest gadgets. My stepdad, Mike, owns it, and he knows everything about VCRs, answering machines, camcorders, remote controls, cordless phones, and cassette players. Mike taught me how to program the VCR so that I can tape my favorite TV shows. When Sarah and I watch them on the weekend, we fast-forward through the commercials.",
  ],
  quiz: PriceQuiz,
  // videos: ["6150341103001"],
  camera: [[-3.3472, -3.0666, 4.059], [-4.3241, -3.9045, 3.4884], cameraSpeed],
};
const SmileysArchade = {
  id: 7,
  title: "Smiley's Arcade",
  images: arcadeImages,
  copy: [
    "This is the best place in the whole mall: Smiley’s Arcade. I could spend all day at Smiley’s—or at least until my quarters run out. I love playing video games. I only wish there were more girl characters. That’s why I made up my very own video game. The hero is a girl—a space explorer named Crystal Starshooter—who is brave and kind and is on a mission to save the earth from solar radiation.",
  ],
  camera: [[-3.1915, 0.5436, 3.3164], [-3.7399, 0.926, 3.267], cameraSpeed],
  game: [
    {
      gameUrl: "https://www.poptropica.com/haxe/play/StarShooter.html?cmg_iframe=1&npc_name=WildFire",
      gameTitle: "StarShooter",
      gamePoster: starShooterImage
    },
    


    {
      gameUrl: "https://www.poptropica.com/haxe/play/BotBreaker.html?cmg_iframe=1&npc_name=WildFire",
      gameTitle: "BotBreaker",
      gamePoster: botBreakerImage
    }
  ],
};
const TheBookShelf = {
  id: 8,
  title: "The Book Shelf",
  images: bookImages,
  copy: [
    "The Book Shelf is another store I always visit when I’m at the mall. When I got my pet, Parsley, I came here to buy a book about taking care of guinea pigs. They also have a ton of magazines to look at. If one of my favorite singers is on the cover, I have to buy it!",
  ],
  books: [
    {
      cover: courtneyBookCover,
      insideText: "Read An Excerpt",
      title: "Courtney Changes The Game",
      author: "Author",
      summery: [
        "Four days later, when Courtney arrived at school,her classroom looked entirely different. The projects that had decorated the bulletin boards before the holiday break were gone. In their place, Courtney’s teacher, Mr. Garcia, had put up posters of outer space. A series of photos now hung on the wall behind Mr. Garcia’s desk: five men and two women, all smiling, wearing identical blue jumpsuits and holding space helmets.",

        "“Welcome back!” Mr. Garcia greeted students as they took their seats. Mr. Garcia was everyone’s favorite third grade teacher because he made school fun. He had shaggy dark hair and a mustache and beard, and he liked to wear Hawaiian shirts or suspenders—sometimes both at the same time. Today he was wearing a red shirt with yellow pineapples and rainbow suspenders with a “Save the Whales” button.",

        "As the students got settled, Mr. Garcia closed the classroom door. “I hope everyone had a fun break,” he said. Then he did an effortless moonwalk back to his desk.",

        "“What, you think I’m too old to break-dance?” Mr. Garcia said when the kids laughed. “I’m trying to get you all psyched for the big event of 1986!”",

        "“What big event?” Sarah asked.",

        "“The Challenger launch!” Mr. Garcia said.",

        "“The space shuttle?” another kid asked.",

        "“Yes! The twenty-fifth space shuttle mission,” Mr.Garcia explained. “The Challenger is launching on January twenty-third. That means we need to get prepared.”",

        "“For what?” Courtney asked. “We’re not getting shot up into outer space.”",

        "“Maybe not,” Mr. Garcia acknowledged, “But Christa McAuliffe is.” He pointed to a photo on the wall of a woman with curly brown hair. “She’s a high school teacher. When she goes into orbit, she’ll become the first teacher to go into space!” Surprised murmurs rippled through the room. “To honor that achievement,” Mr. Garcia went on, “thousands of kids in schools across the country are going to watch the shuttle launch live on television—including our school!”",

        "Courtney glanced at Kip. They were huge Star Wars fans and had seen the movies together dozens of times. Kip raised his hand and said, “If a teacher’s going to space, they should send some students, too. I’ll go!”",

        "The class laughed. “Well, no students this time, Kip,” Mr. Garcia explained. “But Mrs. McAuliffe will be doing experiments in space, and they’ll be taped so that we can watch them.” He paused and waggled his eyebrows. “And, on day four, Mrs. McAuliffe will teach from space! We’ll watch that live, just like the launch.”",

        "“Whoa. That’s so cool.” Sarah grinned.",

        "“I know!” Mr. Garcia replied, snapping his suspenders. “Now, Christa McAuliffe won’t be the first American woman to go into space—that was Sally Ride—but Mrs. McAuliffe will be the first civilian to make it out of the atmosphere.” Mr. Garcia paused. “Women are achieving new milestones every day.”",

        "“Like your mom!” Sarah said to Courtney. Then she turned to Mr. Garcia. “Courtney’s mom is running for mayor.”",

        "Mr. Garcia and the whole class turned to look at Courtney, who felt her face turn pink from the attention.",

        "“She is?” Mr. Garcia asked. When Courtney nodded, Mr. Garcia beamed. “That’s fantastic!” He snapped his suspenders again. “If she wins, I believe she’d become Orange Valley’s first female mayor. That would be a historic accomplishment!”",

        "Courtney looked at Christa McAuliffe’s photo. Christa reminded her of Mom. They both had curly hair and wide smiles, and they were both trying to accomplish big things.",

        "“Your mom doesn’t know how to be mayor,” a kid named Justin Wilson told Courtney abruptly. He smirked, flipping up his shirt collar. “She works at a park.”",

        "Courtney was speechless, but Sarah whirled around in her chair to face Justin.",

        "“Courtney’s mom runs the whole parks department,” Sarah snapped, “Besides, you probably don’t even know what the mayor does.”",

        "“Yeah,” Courtney echoed, grateful for her friend. Sarah never had a problem knowing what to say.",

        "“My mom’s worked on tons of political campaigns,” Sarah continued, “and she thinks Courtney’s mom could be the best mayor Orange Valley has ever had!”",

        "“Whatever,” Justin said. “It’s not like—”",

        "“Boys and girls,” Mr. Garcia interrupted, “local politics are important, but let’s get back to our space project. Take out your notebooks, please. I’ve got an assignment for you.”",

        "Justin Wilson is such a pain, Courtney thought as she opened a purple notebook to a clean page and wrote the date on the top line: January 6, 1986.",

        "“The Challenger launch is an opportunity for us to think about what exploration and discovery mean in our own lives,” Mr. Garcia said enthusiastically. “You might not want to travel into space, but I bet that, like the astronauts, each of you has a dream of your own that you want to achieve.” Mr. Garcia paused, and everyone looked at him, waiting. “So I want each of you to dream big and prepare a five-minute class presentation explaining your personal passion. You can use any medium you want—words, pictures, even music—but whatever you do, it has to be uniquely you.”",

        "Kip whipped around in his seat to face Courtney. “I’m gonna make a movie!” he whispered.",

        "“Cool!” Courtney replied. As Kip turned back to the front, however, uncertainty formed a knot in her stomach. What’s my big dream? she wondered. Do I even have one",

        "* *",

        "“My movie’s going to be a cross between Ghostbusters and The Goonies,” Kip mused, poking a straw into his juice pouch during lunch in the cafeteria. “I bet my dad will let me use his Betamax video camera if I promise to be careful. I could even get Toby to be in it, too!”",

        "“Toby—your dog?” Courtney asked, wrinkling her nose in surprise.",

        "Across the table, Sarah said, “Since my big dream is to travel, I’m going to plan a trip around the world and include every place I want to visit.”",

        "“That sounds rad,” Kip said.",

        "“I know, right?” Sarah replied eagerly. “What are you going to do, Courtney?”",

        "“I’m still thinking about it,” Courtney said. She bit into her bologna and cheese sandwich, wondering if she was the only one in class who hadn’t come up with an idea yet.",

        "“Make sure you pick something you love,” Sarah suggested. Sarah really enjoyed giving advice.",

        "“But I love too many things,” Courtney replied. “Movies, and music, and video games—” She gasped midsentence, hit by a blast of inspiration. “I know—I’ll create my own video game!”",

        "“That sounds super difficult,” Sarah said.",

        "“Yeah,” Kip agreed. “I mean, you’re a total pac-man master, but do you know how to program a computer game?”",

        "“I’m not going to actually make a computer game,” Courtney clarified. “I’m going to think up the characters and the world and the rules, and then explain the game in my presentation.”",

        "“Ohhhh,” Kip said. “That makes sense.”",

        "“Make sure you think up great bad guys,“ Sarah said importantly. “Something scary, like spiders.”",

        '“Or irritating,” Courtney replied. “Like Justin Wilson.” Courtney pictured a villain with a shirt collar standing up so tall that it blocked his face.",',
      ],
    },
    {
      cover: courtneyNewBookCover,
      insideText: "Read An Excerpt",
      title: "Courtney Friendship Superhero",
      author: "Author",
      summery: [
        "Halloween was on a Friday night, which seemed to make the holiday extra-spooky fun. Kip, Sarah, and Isaac all met at Courtney’s house to go trick-or-treating. Sarah was dressed as an angel, Kip was a vampire, and Isaac was a pirate. Courtney’s costume was everyone’s favorite.",
        "“Crystal Starshooter!” Isaac said. “How did you make the ray blaster?”",
        "“It’s an old hairdryer,” Courtney confessed. “Mike helped me take the cord off.”",
        "Outside, Courtney’s mom was taking pictures of Rafi in his homemade robot costume. She waved Courtney and her friends together and snapped a photo.",
        "It was Rafi’s first time dressing up, and he wanted to trick-or-treat with the big kids. Rafi’s robot costume made it hard for him to walk, so it took forever to get from one house to the next. After the first block, Mom took Rafi’s hand and waved Courtney and her friends off on their own. For the next two blocks, they ran from house to house, pausing to catch their breath only as long as it took the front door to open.",
        "“Candy break,” Kip announced when they got to a corner. “Everyone has to eat whatever they grab. On the count of three.”",
        "As Kip counted, they all reached into their bags. On “three,” Courtney and Sarah both pulled out a peanut butter cup. Isaac got a Milky Way. Kip grabbed a box of raisins.",
        "“This is bogus!” Kip cried as the others laughed.",
        "“I’ll trade you,” Isaac said, offering his Milky Way.",
        "“Deal,” Kip said, grabbing the chocolate.",
        "“Really?” Courtney said to Isaac.",
        "“Raisins are grody!” Sarah exclaimed.",
        "Isaac popped a raisin into his mouth. “Raisins are nature’s candy.”",
        "For more than an hour, Courtney and her friends roamed the neighborhood, laughing and shouting and taking candy breaks. “This is the best Halloween I’ve had in years,” Isaac announced as they headed back to Courtney’s.",
        "“Isn’t there trick-or-treating in Ohio?” Sarah asked.",
        "“Um, yeah,” Isaac said, stopping to stare at a front yard that had been transformed into a misty cemetery. “But it isn’t anything like this. How’d they do that?”",
        "“It’s a Halloween mystery,” Kip said, whipping his vampire cape around him.",
        "“Dry ice,” Sarah explained.",
        "“Hey, do you guys want to go to the arcade tomorrow?” Kip asked. “I heard that Smiley just got Super Mario Brothers!”",
        "“Really?” Isaac said eagerly. “I heard the graphics are totally tubular.”",
        "Courtney, Sarah, and Kip laughed at the way Isaac said “totally tubular.” He’d never heard it before he moved, and now it was his favorite California saying.",
        "“Smiley’s it is,” Courtney said. She looked at Sarah, who was spending the night. “Does that sound good?”",
        "Sarah nodded. “Let’s meet at noon. Then we can catch one of the three o’clock movies at the mall theater.”",
        "Isaac unwrapped a piece of candy and popped it in his mouth. “Yes! Let’s make this Halloween fun last all weekend.”",
        "The next day, Kip was already playing Super Mario Brothers when Courtney and Sarah arrived at Smiley’s.",
        "“Isaac’s not here yet?” Courtney asked. “Weird.” After twenty minutes, Courtney left the arcade and scanned the mall, searching for Isaac.",
        "“Maybe he forgot,” Sarah said, when Courtney came back into the arcade.",
        "“No way,” Kip said. “That kid lives to game. Besides, he was totally psyched last night.”",
        "“I’m going to call him,” Courtney said. She went to the pay phone outside the arcade, slid two dimes into the slot, and dialed Isaac’s number. The phone rang and rang until the answering machine picked up. Courtney left a message. When Courtney hung up, Sarah was standing next to her. “Maybe he had too much candy last night and ended up with a stomach ache today,” Sarah suggested.",
        "“Yeah, maybe. But I think he would have called one of us this morning.” Courtney sighed. She took one last look around the mall before following Sarah back into the arcade.",
      ],
    },
    // {
    //   cover: "/Book2.jpg",
    //   insideText: "Inside Text",
    //   title: "Title",
    //   author: "Author",
    //   summery: "Summery",
    // },
  ],
  camera: [[-2.0512, 1.5439, 3.8931], [-2.0878, 1.9137, 3.7505], cameraSpeed],
};
const RadianceSalon = {
  id: 9,
  title: "Radiance Salon",
  images: salonImages,
  copy: [
    "Not that long ago, Mom and Tina and I had a girls’ day at Radiance Salon. Mom let me get my ears pierced, and she let Tina get a perm! I love wearing earrings, and Tina really likes having curly hair. Tina’s the hair expert in our family. She can copy any style she sees on MTV, and she has, like, a million hair ties. If she’s in a good mood, she lets me borrow one. Want to see some rad hair styles?",
  ],
  videos: [
    "J344978",
    "J361518",
    "J384870",
    "J399405"
    // "6150340394001",
    // "6150338516001",
    // "6150338518001",
    // "6150339127001",
  ],
  camera: [[1.6779, 1.1211, 4.1107], [1.5668, 2.2462, 3.6768], cameraSpeed],
};

export const stores = [
  MeetingArea,
  Cinema,
  Valeries,
  FoodCourt,
  Tunes,
  Damicos,
  SmileysArchade,
  TheBookShelf,
  RadianceSalon,
];

export const getStore = (id) => {
  if (!id) return stores[0];
  return stores.find((s) => parseInt(id) === parseInt(s.id));
};
